<ada-container
	verticalSpacing="medium"
	[padding]="ui.Spacing.SPACING_LARGE"
>
	<ada-alert
		*ngIf="errorMessage | async as error"
		type="error"
		[title]="error"
		[isClosable]="false"
	></ada-alert>

	<!-- General Info -->
	<ada-card>
		<ada-text
			data-container-selector="ada-card-header"
			content="General Information"
		></ada-text>
		<ada-container
			data-container-selector="ada-card-body"
			horizontalSpacing="medium"
			verticalSpacing="medium"
			[colCount]="4"
		>
			<!-- Name -->
			<ada-label
				content="Name"
				id="editor-name-input"
				[isRequired]="true"
				[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
			></ada-label>
			<ada-input
				data-testid="editor-name-input"
				labelElementId="editor-name-input"
				placeholder="End of Life Product Name"
				[debounce]="100"
				[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
				[showAsFullWidth]="true"
				[(value)]="context.name"
			></ada-input>

			<!-- Reason -->
			<ada-label
				content="Reasoning"
				id="editor-reason-input"
				[isRequired]="true"
				[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
			></ada-label>
			<ada-input
				data-testid="editor-reasoning-input"
				labelElementId="editor-reason-input"
				minHeight="120px"
				placeholder="Reasoning"
				type="textarea"
				[debounce]="100"
				[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
				[showAsFullWidth]="true"
				[(value)]="context.reason"
			></ada-input>

			<!-- Replacement Product Id -->
			<ada-label
				content="Replacement Product"
				[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
			></ada-label>
			<ada-object-list
				#ProductObjectList
				data-testid="editor-replacement-input"
				[isMultiselect]="false"
				[javaClassName]="softwareProductClassName"
				[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
				[objectIds]="context?.replacementProductId"
				(objectIdsChange)="context.replacementProductId = $event"
			/>
		</ada-container>
	</ada-card>

	<!-- Cpe -->
	<ada-card [collapseEnabled]="true">
		<ada-label
			data-container-selector="ada-card-header"
			content="Unsupported CPEs"
			[isRequired]="true"
		></ada-label>
		<ada-container
			data-container-selector="ada-card-body"
			[colCount]="0"
		>
			<ada-object-list-builder
				#CpesBuilderInput
				data-testid="editor-cpes-input"
				objectName="CPE Match String"
				[objectConfig]="cpesBuilderConfig"
				(customObjectsChange)="setCpeSearchStrings($event)"
			>
			</ada-object-list-builder>
		</ada-container>
	</ada-card>

	<!-- Affected CVEs -->
	<ada-card
		[collapseEnabled]="true"
		[isExpanded]="!(context?.objectId | isEmptyInput: true)"
	>
		<ada-label
			data-container-selector="ada-card-header"
			content="Affected CVEs"
		>
			<ada-text
				content="The affected CVEs given the attached CPE Match Strings"
				data-container-selector="label-info-text"
			></ada-text>
		</ada-label>
		<ada-container data-container-selector="ada-card-body">
			<ada-cve-display-anchor [cves]="context?.cveIds"></ada-cve-display-anchor>
		</ada-container>
	</ada-card>
</ada-container>
